import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Strong N Free (b_743k1dnnoa, advertiser 7188666366224471029).
// Lifetime complete-month metrics through Aug 2026.
export const advStrongNFree: FaireAdvertiserProfileEntity = {
  token: "adv_strong_n_free",
  type: "advertiserProfile",
  archetype: "budget-capped",
  displayName: "Strong N Free",
  brandToken: "b_743k1dnnoa",
  audienceType: "NEW_AND_RETURNING",
  globalStatus: "ACTIVE",
  tenureMonths: 11,
  budget: {
    totalBudgetDollars: 2000,
    sharedBudgetDollars: 2000,
    spendingMode: "MAXIMUM",
    nextRenewsAtDate: "2026-10-01",
    nextBillsAtDate: "2026-10-04",
  },
  overview: {
    numCustomersAcquired: 39,
    numReorderConversions: 15,
    numTotalConversions: 54,
    totalAdsSalesDollars: 28822,
    newCustomerAdsSalesDollars: 21500,
    reorderAdsSalesDollars: 7322,
    totalAdsSpendDollars: 5442,
    newCustomerAdsSpendDollars: 4769,
    reorderAdsSpendDollars: 673,
    newCustomerBestEstimateFirstYearRoas: 5.27,
    reorderRoas: 10.88,
    combinedFirstYearRoas: 5.96,
    numNewCustomerAdsOrders: 53,
    numReorderAdsOrders: 15,
  },
  availableCredit: { totalRemainingDollars: 0 },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 930,
      maxRecommendedBudgetDollars: 1860,
      isEligibleForIncreaseRec: false,
    },
    reorder: {
      minRecommendedBudgetDollars: 150,
      maxRecommendedBudgetDollars: 300,
      isEligibleForIncreaseRec: false,
    },
  },
  campaignTokens: ["camp_sn_new", "camp_sn_reorder"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
